import React from 'react';

import './SidePanelStyles.scss';

export const SidePanel = (props: any) => {
	return (
		<div className='side-panel-main'>
			{props.children}
		</div>
	);
};
